import React from 'react';
import SaleTypeForm from "../../components/forms/sale-type-form";

export default () => {
    return <SaleTypeForm/>
}